import {Injectable} from '@angular/core';
import {ApplicationListVO, ApplicationVO} from './application.interfaces';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {CrudEffects} from '@abydos-angular/store';
import {applicationDefinition} from './application.reducers';
import {ApplicationRepository} from './application.repository';

@Injectable()
export class ApplicationEffects extends CrudEffects<ApplicationVO, ApplicationListVO> {

    /*
      Minta Effect
      SampleEffect = createEffect(() => this.actions.pipe(
        ofType({{action_type}}),
        switchMap(() => {
          return this.crudRepository.fgv().pipe(
            map((payload) => {
              return {payload: payload};
            })
            , toActionCreatorPayload(result_action, HandleErrorAction)
          );
        })
      )
    );
    */
    constructor(actions: Actions, private applicationRepository: ApplicationRepository) {
        super(actions, applicationRepository, applicationDefinition);
    }
}
